import type { Ref } from 'react';
import { Button as AriaButton, type ButtonProps as AriaButtonProps } from 'react-aria-components';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

export interface ButtonProps extends Omit<AriaButtonProps, 'className'> {
  variant?: ButtonVariant;
  size?: 'default' | 'small';
  /** Stretch to the container width (used for stacked mobile actions). */
  block?: boolean;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}

// The one button system (DESIGN_SYSTEM.md §10.1). At most one primary per view.
export function Button({
  variant = 'secondary',
  size = 'default',
  block = false,
  className,
  ...props
}: ButtonProps) {
  const classes = [
    styles.button,
    styles[variant],
    styles[size],
    block ? styles.block : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <AriaButton {...props} className={classes} />;
}
